import module from 'cheques/module.js'
import template from './template.html'

const estados = [
  {value: 't', descripcion: 'Tránsito'},
  {value: 'r', descripcion: 'Retenido'},
  {value: 'x', descripcion: 'Cancelado'},
  {value: 'c', descripcion: 'Cobrado'},
]

export class ChequesListadoListaItemComponent {
  data = null
  onEdit = null
  modificandoDialogo = false
  editando = false

  constructor (ChequesEmpresasCuentaBancariaChequesCheque, $timeout, $notify, $api, $http, $window) {
    this.ChequesEmpresasCuentaBancariaChequesCheque = ChequesEmpresasCuentaBancariaChequesCheque
    this.$timeout = $timeout
    this.$notify = $notify
    this.$api = $api
    this.$http = $http
    this.$window = $window
    this.estados = estados
  }

  $onInit () {
    switch (this.data.status) {
      case 't':
        this.data.status_descripcion = 'Tránsito'
        break

      case 'x':
        this.data.status_descripcion = 'Cancelado'
        break

      case 'r':
        this.data.status_descripcion = 'Retenido'
        break

      case 'c':
        this.data.status_descripcion = 'Cobrado'
        break
    }

    this.link = this.$api.link('/api/empresa/banco/cuenta/impresion', {folio: this.data.folio})
  }

  editar () {
    this.editando = true

    this.ChequesEmpresasCuentaBancariaChequesCheque.put(this.data)
      .then(() => {
        this.editando = false
        this.modificandoDialogo = false
        this.$onInit()
        this.$notify.success('Cheque modificado con éxito.')
      })
  }

  imprimir () {
    const pdfParams = {folio: this.data.folio}

    return this.$http.get('/api/empresa/banco/cuenta/impresion', {
      params: pdfParams,
      responseType: 'blob',
    })
      .then((response) => {
        let url = this.$window.URL.createObjectURL(response.data)
        let window = this.$window.open(url, 'cheque')

        this.$timeout(() => (this.$window.URL.revokeObjectURL(url)), 5000)

        if (window) {
          window.focus()
        } else {
          this.error = 'No se pudo mostrar'
        }
      })
  }
}

module.component('chequesListadoListaItem', {
  controller: ChequesListadoListaItemComponent,
  template,
  bindings: {
    data: '<',
    onEdit: '&',
  },
})



// WEBPACK FOOTER //
// ./src/cheques/components/listado/lista/item/component.js